<template>
    <div>
        <span>
            <router-link :to="{name:'PlanningHome'}" tag="a">
                <i class="fas fa-arrow-left"></i>
            </router-link>
            <span class="title-separator text-muted">|</span>
            <span class="mr-2">{{ scheduledDate.format("MMMM DD") }}:</span>
            <router-link :to="{name:'DayTemplateDetails', params:{ dayTemplateUid: safeCurrentDayTemplate.uid}}">
                {{ safeCurrentDayTemplate.name }}
            </router-link>
        </span>
    </div>
</template>
<script>
    import moment from 'moment'
    import { mapState } from 'vuex';
    import {safeObj} from "@/utils/safeObj";

    export default {
        name: "PlanningHeader",
        computed: {
            ...mapState({
                currentDayTemplate: state => state.Templates.currentDayTemplate,
            }),
            scheduledDate() {
                return moment(this.$route.params.planningDate);
            },
            safeCurrentDayTemplate(){
                return safeObj(this.currentDayTemplate) && this.currentDayTemplate.dayTemplate
            }
        }
    }
</script>
